export default __webpack_public_path__ + "static/media/motorcycle-nav-completed.495331d0.svg";